import actionTypes from 'app/actions/action-types';

export default (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_WIDGETS_SUCCESS:
      return false;
    case actionTypes.FETCH_WIDGETS_FAILURE:
      return true;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/widgets/is-maintenance.js